/**
 * Centralized Map of all running conductor FTs and AB tests
 * scope to use -- viewer-apps-9a5d83fd-8570-482e-81ab-cfa88942ee60
 * use `Meta Site id` as a seed value
 */
export const EXPERIMENTS = {
  USE_DISCOUNT_ON_ORDERING_PAGE: 'useDiscountOnOrderingPage',
  ALLOW_MENU_ITEM_SEO_RENDER_TIME: 'allowMenuItemSeoRenderTimeForOLO',
  ADD_WARMUP_DATA_TO_ONLINE_ORDERS_WIDGET: 'addWarmupDataToOnlineOrdersWidget',
  CHECKOUT_DELIVERY_OPTIONS:
    'restaurantsShouldOmitDeliveryTimeSlotForScheduledDeliveryOrders',
  ORDERS_STUDIO_2_THUMBNAILS: 'ordersStudio2Thumbnails',
  QUICK_ADD_TO_CART_BUTTON: 'quickAddToCartButton',
} as const;

export type ExperimentName = (typeof EXPERIMENTS)[keyof typeof EXPERIMENTS];
